import React from 'react';
import Content from '@component/common/content';
import Scroll from '@component/common/scroll';
import Landing from '@component/iyagigo/landing';

const LandingPage: React.FC = () => (
  <Content top='0px' bottom='0px'>
    <Scroll direction='y' height='100%'>
      <Landing />
    </Scroll>
  </Content>
);

export default LandingPage;
